import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./css/animation.css";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import index from "./store";
import { Provider } from "react-redux";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<Provider store={index}>
		<App />
	</Provider>,
);
